import { render, staticRenderFns } from "./leave.vue?vue&type=template&id=0fdd167e"
import script from "./leave.vue?vue&type=script&lang=js"
export * from "./leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdd167e')) {
      api.createRecord('0fdd167e', component.options)
    } else {
      api.reload('0fdd167e', component.options)
    }
    module.hot.accept("./leave.vue?vue&type=template&id=0fdd167e", function () {
      api.rerender('0fdd167e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activiti/leave.vue"
export default component.exports